import React from 'react';
import styles from '../css/comuns/HelpSection.module.css';
import { config } from '../../data';

const HelpSection = () => {
  const getCardImage = (cardId) => {
    const imageMap = {
      'faq': config.images.helpSection.perguntasFrequentes,
      'atendimento': config.images.helpSection.atendimento,
      'planos': config.images.helpSection.planos,
    };
    return imageMap[cardId];
  };

  const getCardLink = (card) => {
    return card.link === 'whatsapp' ? config.links.social.whatsapp.url : card.link;
  };

  return (
    <section className={styles['custom-section']}>
      <div className={`container ${styles['content-wrapper']} py-5`}>
        <div className="row align-items-center mb-5">
          <div className="col-lg-6 mb-4 mb-lg-0">
            <h1 className={`text-white ${styles['custom-text']}`}>
              {config.texts.helpSection.titulo} <span className={styles['accent-text']}>{config.texts.helpSection.tituloDestaque}</span><br />
              {config.texts.helpSection.subtitulo} <span className={styles['accent-text']}>{config.texts.helpSection.subtituloDestaque}</span>
            </h1>
            <p className="text-white lead mt-4 fs-4">{config.texts.helpSection.descricao}</p>
          </div>
        </div>
        <div className="row g-4">
          {config.content.helpSection.map((card, index) => (
            <div className="col-md-4" key={index}>
              <div className={`${styles['custom-card']} h-100`}>
                <div className="card-body text-center p-5">
                  <div className={styles['custom-icon']}>
                    <img src={getCardImage(card.id)} alt={card.title} className="img-fluid" />
                  </div>
                  <h3 className="card-title fw-bold mb-3">{card.title}</h3>
                  <p className="card-text fs-5">{card.description}</p>
                  <a href={getCardLink(card)} className="btn btn-primary btn-lg mt-3" target={card.link.startsWith("http") || card.link === 'whatsapp' ? "_blank" : "_self"} rel="noopener noreferrer">
                    {card.buttonText}
                  </a>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default HelpSection;